import get from 'lodash/get';
import {createSelector} from 'reselect';
import {UserGroups} from 'utils/DBUtils';

// these selectors accept the Redux store's entire state as an argument.

export const getUserGroup = createSelector(
  state => state.userProfile.profile,
  profile => get(profile, 'userProfile.group', {})
);

// defaults to restricted permissions when no user profile is found.
export const getUserGroupName = createSelector(
  getUserGroup,
  group => get(group, 'name', UserGroups.RestrictedAdmin)
);

export const getUserGroupRank = createSelector(
  getUserGroup,
  group => get(group, 'rank', Infinity) // 0 is root, so default to "lowest" possible rank.
);

export const getUserResourcePermissions = createSelector(
  getUserGroup,
  group => get(group, 'resourcePermissions', [])
);

// selector factory: pass it an element from ResourceApi.Types and get a selector for the
// user's permitted Resource API actions for that resource type.
export const getUserResourceActions = resourceType => createSelector(
  getUserResourcePermissions,
  resourcePermissions => {
    const resourcePermissionsForType = resourcePermissions.find(resourcePermission => (
      resourcePermission.name === resourceType.toLowerCase()
    ));

    const resourceActionsForType = get(resourcePermissionsForType, 'resourceActions', []);

    return resourceActionsForType;
  }
);

export const getUserResourceFieldPermissions = resourceType => createSelector(
    getUserResourcePermissions,
    resourcePermissions => {
        const resourcePermissionsForType = resourcePermissions.find(resourcePermission => (
            resourcePermission.name === resourceType.toLowerCase()
        ));

        return get(resourcePermissionsForType, 'resourceFieldPermissions', []);
    }
);

export const getUserServicePermissions = createSelector(
  getUserGroup,
  group => get(group, 'servicePermissions', [])
);

// selector factory: pass it an element from ResourceApi.Types and get a selector for the
// user's permitted Service API actions for that resource type.
export const getUserServiceActions = resourceType => createSelector(
  getUserServicePermissions,
  servicePermissions => {
    const servicePermissionsForType = servicePermissions.find(servicePermission => (
      servicePermission.name === resourceType.toLowerCase()
    ));

    const serviceActionsForType = get(servicePermissionsForType, 'actions', []);

    return serviceActionsForType;
  }
);

export const getUserBreakTypes = createSelector(
  getUserGroup,
  group => get(group, 'breakTypes', [])
);

export const getUserLangs = createSelector(
    getUserGroup,
    group => get(group, 'langs', [])
);



// WEBPACK FOOTER //
// ./public/pages/Profile/selectors.js